import capitalizeFirstLetter from './capitalizeFirstLetter';

export default capitalizeFirstLetter;
